import React, { useEffect } from "react";

/**
 * GTMProvider
 * Dynamically injects Google Tag Manager into the app.
 * Uses the container ID from environment variables.
 */
const GTMProvider = ({ children }) => {
  const gtmId = process.env.REACT_APP_GTM_ID;

  useEffect(() => {
    if (!gtmId) {
      console.warn("⚠️ GTMProvider: Missing GTM ID (check REACT_APP_GTM_ID)");
      return;
    }

    // Prevent duplicate injection (important in React 18 strict mode)
    if (document.getElementById("gtm-script")) return;

    // Initialize dataLayer if it doesn't exist
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    // Create GTM <script>
    const script = document.createElement("script");
    script.id = "gtm-script";
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
    document.head.appendChild(script);

    // Add <noscript> fallback (optional)
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `<iframe src="https://www.googletagmanager.com/ns.html?id=${gtmId}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
    document.body.insertBefore(noscript, document.body.firstChild);

    if (process.env.NODE_ENV === "development") {
      console.log(`✅ Google Tag Manager loaded: ${gtmId}`);
    }

    return () => {
      // Optional cleanup — generally GTM stays loaded for the app lifetime
      // but if you ever unmount this (in microfrontends etc.), remove the script
      const scriptEl = document.getElementById("gtm-script");
      if (scriptEl) scriptEl.remove();
    };
  }, [gtmId]);

  return <>{children}</>;
};

export default GTMProvider;